import { initializeApp } from '../app.js';

import OrderChangeButtons from '../components/Order/ChangeButtons.vue';
import OrderPayment from '../components/Order/Payment.vue';
import OrderPaymentBillingDataModal from '../components/Order/PaymentBillingDataModal.vue';
import OrderSetupPopup from '../components/Order/SetupPopup.vue';
import CancelOrderPopup from '../components/Order/CancelOrderPopup.vue';
import TrustpilotPopup from '../components/Order/TrustpilotPopup.vue';
import InsurancePopup from '../components/Order/InsurancePopup.vue';
import BirthdayVoucherPopup from '../components/Order/BirthdayVoucherPopup.vue';
import OrderRevocation from '../components/Order/Revocation.vue';
import ProductCardContainer from '../components/ProductCardContainer.vue';
import VignetteProductCard from '../components/VignetteProductCard.vue';
import TollProductCard from '../components/TollProductCard.vue';
import OrderForm from '../components/OrderForm.vue';
import EuropamautOrderForm from '../components/Europamaut/EuropamautOrderForm.vue';
import OrderServiceFeeInfo from '../components/Order/ServiceFeeInfo.vue';
import Order from '../components/Order.vue';
import OrderCheckout from '../components/Order/Checkout/Checkout.vue';
import OrderCheckoutPaymentMethods from '../components/Order/Checkout/PaymentMethods.vue';
import PaymentMethods from '../components/PaymentMethods.vue';
import EvidenceContainer from '../components/EvidenceChecker/Container.vue';
import RouteMap from '../components/Map/Container.vue';

initializeApp('#app', {
    'order-change-buttons': OrderChangeButtons,
    'order-payment': OrderPayment,
    'order-payment-billing-data-modal': OrderPaymentBillingDataModal,
    'order-setup-popup': OrderSetupPopup,
    'cancel-order-popup': CancelOrderPopup,
    'trustpilot-popup': TrustpilotPopup,
    'insurance-popup': InsurancePopup,
    'birthday-voucher-popup': BirthdayVoucherPopup,
    'order-revocation': OrderRevocation,
    'product-card-container': ProductCardContainer,
    'vignette-product-card': VignetteProductCard,
    'toll-product-card': TollProductCard,
    'order-form': OrderForm,
    'europamaut-order-form': EuropamautOrderForm,
    'order-service-fee-info': OrderServiceFeeInfo,
    order: Order,
    'order-checkout': OrderCheckout,
    'order-checkout-payment-methods': OrderCheckoutPaymentMethods,
    'payment-methods': PaymentMethods,
    'evidence-container': EvidenceContainer,
    'route-map': RouteMap,
});
